export const EmailStatus = {
  RECEIVED: 'received',
  READ: 'read',
  DELETED: 'deleted',
};
